/**
 * This is so we use the same hover/focus across the web. If any changes are needed we can include this file.
 * There may be some scenarios where the hover is different but ideally that is encapsulated in a tweed atom like with the button
 */
import { colors } from './colors'
import { Opacity } from './opacity'

export const onHoverAndFocus = {
  '&:hover': {
    backgroundColor: colors.webActiveBackground,
  },
  '&:focus': {
    backgroundColor: colors.webActiveBackground,
  },
}

export const onHoverAndFocusOpacity = {
  '&:hover': {
    opacity: Opacity.onHover,
  },
  '&:focus': {
    opacity: Opacity.opaque,
  },
}

export const onHoverAndFocusSelect = {
  '&:hover': {
    backgroundColor: colors.webActiveBackground,
    borderColor: colors.webActiveBorder,
  },
  '&:focus': {
    backgroundColor: colors.webActiveBackground,
    borderColor: colors.webActiveBorder,
  },
}

export const fadeInFadeOut = {
  // Fade only
  '@keyframes fadeIn': {
    from: { opacity: Opacity.transparent },
    to: { opacity: Opacity.opaque },
  },
  '@keyframes fadeOut': {
    from: { opacity: Opacity.opaque },
    to: { opacity: Opacity.transparent },
  },
  // Fade + Slide (used only below md)
  '@keyframes fadeInUp': {
    from: { opacity: Opacity.transparent, transform: 'translateY(100%)' },
    to: { opacity: Opacity.opaque, transform: 'translateY(0)' },
  },
  '@keyframes fadeOutDown': {
    from: { opacity: Opacity.opaque, transform: 'translateY(0)' },
    to: { opacity: Opacity.transparent, transform: 'translateY(100%)' },
  },
}
